export default function MaterialCreateCiqIcon({
  size = 12,
  className = "fill-black",
  opacity = "0.6"
}: {
  size?: number;
  className?: string;
  opacity?: string;
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 20 19"
      fill="none"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.63695 16.3361L12.886 13.9015C12.8417 14.1399 12.8186 14.3857 12.8186 14.6369C12.8186 15.0514 12.8812 15.4513 12.9983 15.8273L9.10277 18.0588C8.81572 18.2232 8.45721 18.2232 8.17015 18.0588L0.219959 13.506C0.00564291 13.3831 -0.063797 13.118 0.0646859 12.9132C0.102898 12.8524 0.15629 12.8013 0.219959 12.7648L1.3098 12.1408L8.63695 16.3361ZM17.053 8.6984C17.2675 8.82133 17.337 9.0873 17.2082 9.29215C17.1699 9.353 17.1167 9.4041 17.053 9.44059L8.63695 14.2599L0.219959 9.44059C0.00538878 9.31764 -0.0640814 9.05166 0.0646859 8.84684C0.102939 8.78599 0.156222 8.73489 0.219959 8.6984L1.3098 8.07438L8.63695 12.2707L15.9631 8.07438L17.053 8.6984ZM8.17015 0.123203C8.45715 -0.0410678 8.81578 -0.0410675 9.10277 0.123203L17.053 4.67594C17.2675 4.79885 17.3369 5.06486 17.2082 5.26969C17.1699 5.33047 17.1166 5.38165 17.053 5.41812L8.63695 10.2375L0.219959 5.41812C0.00534416 5.29523 -0.0640662 5.02921 0.0646859 4.82437C0.102928 4.76353 0.156224 4.71246 0.219959 4.67594L8.17015 0.123203ZM3.09594 5.04703L8.63695 8.21988L14.177 5.04703L8.63695 1.87418L3.09594 5.04703Z"
        fill="current"
        fillOpacity={opacity}
      />
      <path
        d="M17.2614 11.5908H16.7382C16.6917 11.5908 16.25 11.613 16.25 11.6575V13.8408H14.0698C14.0233 13.8408 14 14.2964 14 14.3408V14.8408C14 14.8853 14.0233 15.3408 14.0698 15.3408H16.25V17.5242C16.25 17.5686 16.6917 17.5908 16.7382 17.5908H17.2614C17.3079 17.5908 17.75 17.5686 17.75 17.5242V15.3408H19.9302C19.9767 15.3408 20 14.8853 20 14.8408V14.3408C20 14.2964 19.9767 13.8408 19.9302 13.8408H17.75V11.6575C17.75 11.613 17.3079 11.5908 17.2614 11.5908Z"
        fill="current"
        fillOpacity={opacity}
      />
    </svg>
  );
}
